"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var getVisibleChildrenRange_1 = __importDefault(require("./getVisibleChildrenRange"));
var useRouteFocused_1 = require("./useRouteFocused");
var debounce = require('lodash.debounce');
var useVisibleCatalogs = function (_a) {
    var catalogs = _a.catalogs, loadRange = _a.loadRange, _b = _a.leadingRows, leadingRows = _b === void 0 ? 0 : _b, _c = _a.preloadRows, preloadRows = _c === void 0 ? 0 : _c;
    var active = (0, useRouteFocused_1.useRouteActive)();
    var scrollContainerRef = (0, react_1.useRef)(null);
    var catalogRows = (0, react_1.useMemo)(function () { return catalogs
        .map(function (catalog, index) { return ({ catalog: catalog, index: index }); })
        .filter(function (_a) {
        var _b;
        var catalog = _a.catalog;
        return ((_b = catalog.content) === null || _b === void 0 ? void 0 : _b.type) !== 'Err' || catalog.content.content !== 'EmptyContent';
    }); }, [catalogs]);
    var measure = (0, react_1.useCallback)(function () {
        if (!active || !scrollContainerRef.current || catalogRows.length === 0)
            return;
        var range = (0, getVisibleChildrenRange_1.default)(scrollContainerRef.current);
        if (range === null)
            return;
        var maxRow = catalogRows.length - 1;
        var firstRow = catalogRows[Math.min(maxRow, Math.max(0, range.start - leadingRows))];
        var lastIndex = Math.min(maxRow, range.end - leadingRows);
        var lastRowIndex = lastIndex < 0 ? firstRow.index - 1 : catalogRows[lastIndex].index;
        var start = Math.max(0, firstRow.index - preloadRows);
        var end = Math.min(catalogs.length - 1, lastRowIndex + preloadRows);
        if (end >= start)
            loadRange({ start: start, end: end });
    }, [active, catalogRows, catalogs.length, leadingRows, preloadRows, loadRange]);
    var onScroll = (0, react_1.useMemo)(function () { return debounce(measure, 250); }, [measure]);
    (0, react_1.useLayoutEffect)(function () {
        measure();
        return function () { return onScroll.cancel(); };
    }, [measure, onScroll]);
    return { catalogRows: catalogRows, scrollContainerRef: scrollContainerRef, onScroll: onScroll };
};
exports.default = useVisibleCatalogs;
